import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Form, Table, Modal, Button, Dropdown } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaRegEye, FaCheck, FaRegQuestionCircle, FaRegImage, FaEdit, FaTrash } from "react-icons/fa";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { CiEdit } from "react-icons/ci";
import { MdOutlineDelete, MdOutlineAudiotrack } from "react-icons/md";
import { GoVideo } from "react-icons/go";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import Paginator from "../../components/common/Pagination";
import { formateDatemdy, capitalizeFirstLetterOfEveryWord, stripHtmlAndTruncate } from "../../utils/Helper";
import DeleteModal from "../../components/common/DeleteModel";
import ApproveModel from "../../components/common/ApproveModel";
import Lesson_Filter from "../Lesson/lesson_filter";
import useMenuPermissions from "../../components/CustomHook/custompermission";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const Lesson = () => {
  const navigate = useNavigate();
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState({});
  const [selectedRange, setSelectedRange] = useState("disabled");
  const [loadEdit, setLoadEdit] = useState(false);
  const [loadQIAV, setLoadQIAV] = useState(false);
  const [errorsE, setErrorsE] = useState({});
  const [errorsQIAV, setErrorsQIAV] = useState({});
  const [lessonList, setLessonList] = useState([]);
  const [lessonslist, setLessonslist] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(20);
  const [count, setCount] = useState(0);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };

  // Modal states
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showAppr, setShowAppr] = useState(false);
  const [showDt, setShowDt] = useState(false);
  const [showQIAV, setShowQIAV] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [outline, setOutline] = useState("");
  const [content, setContent] = useState("");
  const [lessonSingleData, setLessonSingleData] = useState({});
  const [showGtype, setShowGtype] = useState("");
  const [qiavCount, setQiavCount] = useState(5);
  const [deleteType, setDeleteType] = useState("");
  const [dNone, setDNone] = useState("");

  const permissionscontext = useMenuPermissions("/admin/lesson");

  const handleClose = () => {
    setShowEdit(false);
    setShowView(false);
    setShowAppr(false);
    setShowQIAV(false);
    setSelectedId(null);
    setErrorsE({});
    setErrorsQIAV({});
    setDNone("");
  };

  const handleCloseView = () => {
    setDNone("");
    setShowView(false);
  };

  const handleCloseQIAV = () => {
    setShowQIAV(false);
    setShowGtype("");
    setSelectedId(null);
    setQiavCount(0);
    setErrorsQIAV({});
    setDNone("");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "outline") {
      setOutline(value);
    } else if (name === "content") {
      setContent(value);
    }
    setErrorsE((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const handleChangeQIAV = (e) => {
    const { name, value } = e.target;
    if (name === "count") {
      setQiavCount(value);
    } else if (name === "lesson") {
      setSelectedId(value);
    }
    setErrorsQIAV((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  // Status toggle for lesson status (Active/Inactive)
  const handleStatusChangeLesson = async (lesson) => {
    const newStatus = lesson.status === "Active" ? "Inactive" : "Active";
    try {
      const payload = { lesson_id: lesson.id, status: newStatus };
      const res = await APIServices.put(
        `/admin/lessons/update/status`,
        payload,
        headers
      );
      if (res?.data?.status === true) {
        showToast(res?.data?.message || "Success", "success");
        const updatedLessonList = lessonList.map((item) => {
          if (item.id === lesson.id) {
            return { ...item, status: newStatus };
          }
          return item;
        });
        setLessonList(updatedLessonList);
      } else {
        showToast(res?.data?.message || "Something went wrong.", "error");
      }
    } catch (error) {
      console.error("Error updating status:", error);
      showToast("Error updating status", "error");
    }
  };

  useEffect(() => {
    fetchLessonList(currentPage, filters);
    fetchLessonslist();
  }, [currentPage, filters]);

  const fetchLessonList = async (page = 1, filters) => {
    const params = {
      ...filters,
      skip: (page - 1) * limit,
      limit: limit,
    };

    const queryString = Object.entries(params)
      .filter(
        ([_, value]) => value !== "" && value !== undefined && value !== null
      )
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");

    try {
      const response = await APIServices.get(
        `/admin/lessons/lesson_list?${queryString}`,
        headers
      );
      if (response?.status === 200) {
        setLessonList(response?.data?.data?.lessons || []);
        setCount(response?.data?.data?.total);
        setTotalCount(Math.ceil(response?.data?.data?.total / limit) || 0);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setLessonList([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setLessonList([]);
      setTotalCount(0);
    }
  };

  const fetchLessonslist = async () => {
    try {
      const response = await APIServices.get(
        `/admin/lessons/list`,
        headers
      );
      if (response?.status === 200) {
        const approvedLessons = response?.data?.data?.lessons.filter(
          (lesson) => lesson.lesson_status === "Approved"
        );
        setLessonslist(approvedLessons);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setLessonslist([]);
      }
    } catch (error) {
      setLessonslist([]);
    }
  };

  // Edit lesson
  const handleEdit = async () => {
    let newErrors = {};
    if (!outline?.trim()) {
      newErrors.outline = "Please enter outline.";
    }
    if (!content?.trim()) {
      newErrors.content = "Please enter content.";
    }
    setErrorsE(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }
    setLoadEdit(true);
    try {
      if (selectedId !== null) {
        const payload = { name: outline, lesson_text: content };
        const res = await APIServices.put(
          `/admin/lessons/edit/${selectedId}`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          fetchLessonList(currentPage, filters);
          setSelectedId(null);
          setLoadEdit(false);
          handleClose();
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
          setLoadEdit(false);
        }
      }
    } catch (error) {
      console.error("Error updating:", error);
      showToast("Error updating lesson", "error");
    } finally {
      setLoadEdit(false);
    }
  };

  // Delete lesson
  const handleDelete = async () => {
    try {
      if (selectedId !== null) {
        const payload = { id: selectedId };
        const res = await APIServices.put(
          `/admin/lessons/delete/${selectedId}`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          const updatedLessonList = lessonList.filter(
            (lesson) => lesson.id !== selectedId
          );
          setLessonList(updatedLessonList);
          setCount(prevCount => prevCount - 1);
          setSelectedId(null);
          setShowDt(false);
          setDNone("");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("Error deleting:", error);
      showToast("Error deleting lesson", "error");
    }
  };

  // Approve lesson
  const handleApprove = async () => {
    setLoadEdit(true);
    try {
      if (selectedId !== null) {
        const res = await APIServices.put(
          `/admin/lessons/approve/${selectedId}`,
          {},
          headers
        );
        if (res?.data?.status === true) {
          showToast(res?.data?.message || "Success", "success");
          fetchLessonList(currentPage, filters);
          setSelectedId(null);
          setShowAppr(false);
          setDNone("");
        } else {
          showToast(res?.data?.message || "Something went wrong.", "error");
        }
      }
    } catch (error) {
      console.error("Error approving:", error);
      showToast("Error approving lesson", "error");
    } finally {
      setLoadEdit(false);
    }
  };

  // Generate QIAV (Quiz/Image/Audio/Video)
  const handleGenerateQIAV = async (e) => {
    e.preventDefault();

    let newErrors = {};
    if (showGtype !== "Lesson" && (selectedId == null || selectedId == "")) {
      newErrors.lesson = "Please select lesson.";
    }
    if (showGtype !== "Audio" && Number(qiavCount) === 0) {
      newErrors.count = "Please enter count.";
    }
    setErrorsQIAV(newErrors);
    if (Object.keys(newErrors).length > 0) {
      return false;
    }

    setLoadQIAV(true);

    try {
      let endpoint = '';
      let payload = {};

      if (showGtype === "Lesson") {
        payload = { topic_id: 0, no_of_lesson: Number(qiavCount) }; // You might need to pass topic_id
        const res = await APIServices.post(
          `/admin/lessons/add`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast("Lesson generated successfully", "success");
          fetchLessonList(currentPage, filters);
        }
      } else if (showGtype === "Quiz") {
        payload = { lesson_id: selectedId, no_of_question: Number(qiavCount) };
        const res = await APIServices.post(
          `/admin/quizzes/add`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast("Quiz generated successfully", "success");
        }
      } else if (showGtype === "Image") {
        payload = { lesson_id: selectedId, no_of_images: Number(qiavCount), media_type: 2 };
        const res = await APIServices.post(
          `/admin/media/add`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast("Image generated successfully", "success");
        }
      } else if (showGtype === "Audio") {
        payload = { lesson_id: selectedId, media_type: 1 };
        const res = await APIServices.post(
          `/admin/media/add`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast("Audio generated successfully", "success");
        }
      } else if (showGtype === "Video") {
        payload = { lesson_id: selectedId, media_type: 3, no_of_images: Number(qiavCount) };
        const res = await APIServices.post(
          `/admin/media/add`,
          payload,
          headers
        );
        if (res?.data?.status === true) {
          showToast("Video generated successfully", "success");
        }
      }

      handleCloseQIAV();
    } catch (error) {
      console.error(`Error generating ${showGtype}:`, error);
      showToast(`Error generating ${showGtype}`, "error");
    } finally {
      setLoadQIAV(false);
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };

  return (
    <>
      <div className="Lesson_inner">
        <div className="mom_header d-flex align-items-center justify-content-between mb-3">
          <h1 className="font_blue_18 font-600">{`Lessons (${count ?? 0})`}</h1>

          <ul className="d-flex align-items-center mom_filter">
            <li
              className="d-flex align-items-center cursor-pointer"
              onClick={() => setShowFilter(true)}
            >
              Filter By{" "}
              <img
                src="/images/Sort.svg"
                className="img-fluid ms-2"
                alt="Sort"
              />
            </li>

          </ul>
        </div>

        <div className="todoList_table">
          <div className="table-responsive">
            <Table className="table">
              <thead className="table-dark">
                <tr>
                  <th>Sr.No</th>
                  <th>Topic Name</th>
                  <th>Lesson Name</th>
                  <th>Create Date</th>
                  <th>Approved by</th>
                  <th>Lesson Status</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>

              {lessonList && lessonList.length > 0 ? (
                <tbody>
                  {lessonList.map((lesson, index) => {
                    let statusClass = '';
                    switch (lesson.lesson_status) {
                      case 'Pending':
                        statusClass = 'warning';
                        break;
                      case 'Approved':
                        statusClass = 'success';
                        break;
                      case 'Rejected':
                        statusClass = 'danger';
                        break;
                      default:
                        statusClass = 'secondary';
                    }

                    return (
                      <tr key={lesson.id}>
                        <td>{lesson.sr_no || (currentPage - 1) * limit + index + 1}</td>
                        <td>
                          <span title={lesson.topic_name}>
                            {lesson.topic_name?.length > 100
                              ? `${lesson.topic_name.substring(0, 100)}...`
                              : lesson.topic_name || "N/A"}
                          </span>
                        </td>
                        <td>
                          <span title={lesson.name}>
                            {lesson.name?.length > 100
                              ? `${lesson.name.substring(0, 100)}...`
                              : lesson.name}
                          </span>
                        </td>
                        <td>{formateDatemdy(lesson.created_at)}</td>
                        <td>
                          {lesson?.approved_by
                            ? capitalizeFirstLetterOfEveryWord(lesson.approved_by)
                            : "N/A"}
                        </td>
                        <td>
                          <span
                            className={`status-text ${statusClass}`}
                            title={lesson?.lesson_status ? capitalizeFirstLetterOfEveryWord(lesson.lesson_status) : "No Status"}
                          >
                            {lesson?.lesson_status
                              ? capitalizeFirstLetterOfEveryWord(lesson.lesson_status)
                              : "N/A"}
                          </span>
                        </td>
                        <td>
                          <Form className="Switch_toggle">
                            <input
                              type="checkbox"
                              id={`switch-${lesson.id}`}
                              checked={lesson.status === "Active"}
                              onChange={() => handleStatusChangeLesson(lesson)}
                              disabled={!permissionscontext.edit}
                            />
                            <label
                              className="position-relative"
                              htmlFor={`switch-${lesson.id}`}
                            >
                              Toggle
                            </label>
                          </Form>
                        </td>
                        <td>
                          <Dropdown className="lession_btn_drop">
                            <Dropdown.Toggle id={`dropdown-${lesson.id}`} variant="light">
                              <HiOutlineDotsHorizontal />
                            </Dropdown.Toggle>

                            <Dropdown.Menu className={dNone === "d-none" ? "d-none" : ""} popperConfig={{ strategy: "fixed" }}>
                              <Dropdown.Item
                                onClick={() => {
                                  navigate(`/admin/lesson-detail/${lesson.id}`);
                                }}
                              >
                                <FaRegEye size={16} /> View
                              </Dropdown.Item>


                              {lesson?.lesson_status === "Pending" ? (
                                <>
                                  {permissionscontext.edit == 1 && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        setShowEdit(true);
                                        setSelectedId(lesson?.id);
                                        setOutline(lesson?.name);
                                        setContent(lesson?.lesson_text);
                                        setDNone("d-none");
                                      }}
                                    >
                                      <CiEdit size={16} /> Edit
                                    </Dropdown.Item>
                                  )}

                                  {(permissionscontext.edit == 1 || permissionscontext.add == 1) && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        setShowAppr(true);
                                        setSelectedId(lesson?.id);
                                        setDNone("d-none");
                                      }}
                                    >
                                      <FaCheck size={16} /> Approve
                                    </Dropdown.Item>
                                  )}

                                  {permissionscontext.delete == 1 && (
                                    <Dropdown.Item
                                      onClick={() => {
                                        setShowDt(true);
                                        setSelectedId(lesson?.id);
                                        setDeleteType("lesson");
                                        setDNone("d-none");
                                      }}
                                    >
                                      <MdOutlineDelete size={16} /> Delete
                                    </Dropdown.Item>
                                  )}
                                </>
                              ) : (
                                <>

                                </>
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      <h4>Lessons not found</h4>
                    </td>
                  </tr>
                </tbody>
              )}
            </Table>
          </div>
        </div>

        <div className="pagination_box mt-4">
          {count > limit && (
            <Paginator
              currentPage={currentPage}
              totalPages={totalCount}
              onPageChange={handlePageChange}
            />
          )}
        </div>
      </div>

      <ToastContainer />


      {/* Edit Modal */}
      <Modal
        show={showEdit}
        size="md"
        onHide={handleClose}
        centered
        backdrop="static"
        className="add_subproduct msl_model td_edit_model"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="font_blue_20 font-600">
            Edit Lesson
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Row className="mb-3 font_blue_18">
            <Col md={12} className="mb-3">
              <Form.Group
                as={Row}
                controlId="outline"
                className="align-items-center"
              >
                <Form.Label
                  column
                  sm={2}
                  className="font_blue_14 font-500 mb-0 text-end"
                >
                  Heading :
                </Form.Label>
                <Col sm={10}>
                  <Form.Control
                    type="text"
                    name="outline"
                    placeholder="Enter outline"
                    value={outline}
                    onChange={handleChange}
                    isInvalid={!!errorsE.outline}
                  />
                  {errorsE.outline && (
                    <div className="invalid-feedback d-block">
                      {errorsE.outline}
                    </div>
                  )}
                </Col>
              </Form.Group>
            </Col>

            <Col md={12} className="mb-3">
              <Form.Group
                as={Row}
                controlId="content"
                className="align-items-start"
              >
                <Form.Label
                  column
                  sm={2}
                  className="font_blue_14 font-500 mb-0 text-end"
                >
                  Description:
                </Form.Label>
                <Col sm={10}>
                  <div className="ckeditor-wrapper">
                    <CKEditor
                      editor={ClassicEditor}
                      data={content}
                      config={{
                        licenseKey: 'GPL',
                        height: '350px',
                        minHeight: '300px',
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setContent(data);
                        // Clear error when content has actual text (not just HTML tags)
                        if (data.replace(/<[^>]*>/g, '').trim()) {
                          setErrorsE(prev => ({ ...prev, content: undefined }));
                        }
                      }}
                    />
                  </div>
                  {errorsE.content && (
                    <div className="invalid-feedback d-block">
                      {errorsE.content}
                    </div>
                  )}
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button
            variant="warning"
            className="success_btn"
            onClick={handleEdit}
            disabled={loadEdit}
          >
            {loadEdit ? "Processing..." : "Update"}
          </Button>
          <Button
            variant="secondary"
            className="cancel_btn"
            onClick={handleClose}
            disabled={loadEdit}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Approve Modal */}
      <ApproveModel
        show={showAppr}
        handleClose={() => {
          setShowAppr(false);
          setDNone("");
        }}
        handle={handleApprove}
      />

      {/* Delete Modal */}
      <DeleteModal
        showdt={showDt}
        handleCloseDt={() => {
          setShowDt(false);
          setDNone("");
        }}
        handledelete={handleDelete}
      />

      {/* Filter Modal */}
      {showFilter && (
        <Lesson_Filter
          appliedFilters={filters}
          show={showFilter}
          onHide={() => setShowFilter(false)}
          onApplyFilter={(filterData) => {
            setFilters(filterData);
            setShowFilter(false);
            setCurrentPage(1);
          }}
          onClear={() => {
            setFilters({});
            setShowFilter(false);
            setSelectedRange("");
            setCurrentPage(1);
          }}
          setSelectedRange={setSelectedRange}
          selectedRange={selectedRange}
        />
      )}
    </>
  );
};

export default Lesson;